<template>
	<form>
		<div class="vx-row">
			<div class="vx-col lg:w-1/2 md:w-1/2 w-1/2">
				<vs-input label="Gewicht in gram" type="number" v-validate="'integer'" name="weight"
						  v-model="product.weight"></vs-input>
				<span class="text-danger text-sm"
					  v-show="errors.has('weight')">{{
						errors.first('weight')
					}}</span>
			</div>
			<div class="vx-col lg:w-1/2 md:w-1/2 w-1/2">
				<label class="multiselect-label">Verpakking</label>
				<vue-multiselect
					placeholder="Verpakking"
					v-model="product.package"
					:options="packages"
					:show-labels="false"
					:allow-empty="false"
					label="name"
				/>
			</div>
			<div class="vx-col w-full">
				<label class="multiselect-label">Levertijd</label>
				<vue-multiselect
					placeholder="Levertijd"
					v-model="deliveryOptions.selected"
					:options="deliveryOptions.options"
					:show-labels="false"
					:allow-empty="false"
					label="name"
				/>
			</div>

			<div class="vx-col w-full">
				<span class="text-danger text-sm"
					  v-show="errors.has('deliveryOption')">{{
						errors.first('deliveryOption')
					}}</span>
			</div>
		</div>
	</form>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import vSelect from 'vue-select';
import {mapActions} from 'vuex';

Vue.use(VeeValidate);
const dict = {
	custom: {
		weight: {
			integer: 'Het gewicht kan alleen uit cijfers bestaan',
		},
	}
};
Validator.localize('en', dict);

export default {
	name: 'shipping',
	components: {
		vSelect,
	},
	props: {
		product: {},
		packages: {},
		deliveryOptions: {},
	},
	data() {
		return {
			updatedProduct: {},
		}
	},
	methods: {
		...mapActions({
			getProducts: 'productStore/getProducts',
			updateProduct: 'productStore/updateProducts',
		}),
		validate() {
			//uncomment when updating delivery code in bol works

			// if (!this.deliveryOptions.selected.toApi) {
			// 	this.$vs.notify({title: 'Error', text: 'Kies een levertijd', color: 'danger'});
			// } else {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.update()
				} else {
					this.$vs.notify({
						title: 'Error',
						text: 'Controleer de gegevens en probeer opnieuw',
						color: 'danger'
					});
				}
			})
			// }
		},
		update() {
			if (this.product.package) {
				this.updatedProduct = {
					product_id: this.product.id,
					weight: this.product.weight,
					delivery_code: this.deliveryOptions.selected.toApi,
					package_id: this.product.package.id,
				};
			} else {
				this.updatedProduct = {
					product_id: this.product.id,
					weight: this.product.weight,
					delivery_code: this.deliveryOptions.selected.toApi,
				};
			}
			this.updateProduct(this.updatedProduct).then(result => {
				this.getProducts();
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Je wijzigingen zijn opgeslagen',
					color: 'success'
				});
			}).catch(error => {
				console.log(error);
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets mis gegaan, probeer het opnieuw',
					color: 'danger'
				});
			});
		}
	}
}
</script>

<style scoped>
.smallLabel {
	padding-left: 5px;
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	font-weight: 400;
	font-size: .85rem;
}
</style>
